import { Injectable } from '@angular/core';
import { Platform, ModalController, App, ToastController } from 'ionic-angular';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { AngularFirestore } from 'angularfire2/firestore';
import { PopupErrorsPage } from '../components/popups/popup-errors/popup-errors';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AlegraServices {

  alegra_api_path = 'https://api.alegra.com/api/v1/';

  constructor(public app: App,
    public platform: Platform,
    private http: HttpClient,
    private globals: Globals,
    private afs: AngularFirestore,
    private modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public translate: TranslateService) {
  }

  /*funcion que recupera contactos de alegra 
    mirar si el email del contacto esta en la lista
    si -> pilllar id del contacto (guardar firestore customer)
    no -> crear contato en alegra y guardar id en el contacto de mct
  */
  async syncronizeMctAlegraCustomers(customer, invoice, date, dueDate, items) {
    //call api
    try {
      //call api
      let _obj_contact = await this.createContact(customer);
      //update customer firestore
      this.afs.collection('customers').doc(customer.UID).update({
        'alegra_contact_id': _obj_contact['id'],
      });
      //create alegra e-invoice
      await this.createAlegraEinvocieAndSaveFirestore(invoice, date, dueDate, _obj_contact['id'], items)
    } catch (error) {
      //error lanzar modal
      let profileModal = this.modalCtrl.create(PopupErrorsPage, { origin: 'alegra', title: 'Alegra', msg: error.error['message'] });
      profileModal.onDidDismiss(data => {
      });
      profileModal.present();
    }
  }


  async createAlegraEinvocieAndSaveFirestore(invoice, date, dueDate, alegra_contact_id, items) {
    try {
      //creamos la einvoice en alegra
      let alegra_einvoice = await this.createAlegraInvoice(invoice, date, dueDate, alegra_contact_id, items);
      //guardamos en invoice de mct
      this.updateFirestoreInvoice(invoice, alegra_einvoice);
      //TOAST
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-efactura-alegra-creada-correctamente'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
      //this.app.getRootNav().push(InvoicesListPage);
    } catch (error) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, { origin: 'alegra', title: 'Alegra', msg: error.error['message'] });
      profileModal.onDidDismiss(data => {
      });
      profileModal.present();
    }
  }

  async getItemOrCreate() {
    //get items de alegra
    let headers = this.getHeader();
    const params = new HttpParams()
      .set('query', 'Ticket');
    const response = await this.http.get(this.alegra_api_path + 'items', { headers, params }).toPromise();
    //
    var item = this.globals.objectToArray(response).find(con => con.name == 'Ticket');
    if (item) {//existe devolvemos id
      return item.id
    } else {//no existe creamos y devolvemos id
      const _response = await this.http.post(this.alegra_api_path + 'items', {
        name: 'Ticket',
        price: 0
      }, { headers }).toPromise();
      return _response['id']
    }
  }

  async createContact(customer) {
    //set headers
    let headers = this.getHeader();
    //call api
    const response = await this.http.post(this.alegra_api_path + 'contacts',
      {
        name: customer.name,
        email: customer.email
      },
      { headers }).toPromise();
    return response;
  }

  async editContact(alegra_contact_id, name, email) {
    //set headers
    let headers = this.getHeader();
    //call api
    try {
      const response = await this.http.put(this.alegra_api_path + 'contacts/' + alegra_contact_id,
        {
          name: name,
          email: email
        }, { headers }).toPromise();
      return response;
    } catch (error) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, { origin: 'alegra', title: 'Alegra', msg: error.error['message'] });
      profileModal.onDidDismiss(data => {
      });
      profileModal.present();
    }
  }

  async createAlegraInvoice(invoice, date, dueDate, client, items) {
    //set headers
    let headers = this.getHeader();
    //call api
    const response = await this.http.post(this.alegra_api_path + 'invoices', {
      date: date,
      dueDate: dueDate,
      client: client,
      items: items
    }, { headers }).toPromise();
    return response;
  }

  async updateFirestoreInvoice(invoice, alegra_einvoice) {
    await this.afs.collection('invoices').doc(invoice.UID).update({
      'alegra_einvoice_id': alegra_einvoice['numberTemplate']['number'],
    });
  }

  async getContacts() {
    //set headers
    let headers = this.getHeader();
    /*
    const params = new HttpParams()
      .set('limit', '100');*/
    //call api
    const response = await this.http.get(this.alegra_api_path + 'contacts/', { headers }).toPromise();
    return response;
  }

  async getAlegraInvoices() {
    //set headers
    let headers = this.getHeader();
    //call api
    const response = await this.http.get(this.alegra_api_path + 'invoices', { headers }).toPromise();
    return response;
  }

  getHeader() {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Basic " + btoa(this.globals.restaurant.alegra_email + ":" + this.globals.restaurant.alegra_token));
    headers = headers.append("Content-Type", "application/x-www-form-urlencoded");
    return headers;
  }

}




/*try {
      let _ojb_contacts = await this.getContacts();
      var contact = this.globals.objectToArray(_ojb_contacts).find(con => con.email == customer.email);
      if (contact) {//si -> pilllar id del contacto (guardar firestore customer)
        //update customer firestore
        this.afs.collection('customers').doc(customer.UID).update({
          'alegra_contact_id': contact.id,
        });
      } else {//no -> crear contato en alegra y guardar id en el contacto de mct
        try {
          //call api
          let _obj_contact = await this.createContact(customer);
          //update customer firestore
          this.afs.collection('customers').doc(customer.UID).update({
            'alegra_contact_id': _obj_contact['id'],
          });
          //create alegra e-invoice
          await this.createAlegraEinvocieAndSaveFirestore(invoice, date, dueDate, _obj_contact['id'], items)
        } catch (error) {
          //error lanzar modal
          let profileModal = this.modalCtrl.create(PopupErrorsPage, { origin: 'alegra', title: 'Alegra', msg: error.error['message'] });
          profileModal.onDidDismiss(data => {
          });
          profileModal.present();
        }
        //
      }
    } catch (error) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, { origin: 'alegra', title: 'Alegra', msg: error.error['message'] });
      profileModal.onDidDismiss(data => {
      });
      profileModal.present();
    }*/


// WEBPACK FOOTER //
// ./src/pages/services/alegraServices.ts